import React, { useEffect, useState } from 'react';
import { useApp } from '../context/appContext';
import { useModal } from '../context/modalContext';
import locationIcon from '../assets/icons/location-icon.svg';
import arrowIcon from '../assets/icons/arrow-icon.svg';
import { getAssetUrl, haversineDistance } from '../utils/lib';
import StoreModal from './shared/StoreModal';
import Address from './shared/Address';
import { fbApiUrl } from "./shared/facebooktrack_config";  

const ListingComponent = ({ selectedLocation }) => {
  const [userLocation, setUserLocation] = useState(selectedLocation);
  const [selectedStore, setSelectedStore] = useState(null);

  const {
    locations,
    form,
    setForm,
    nearestStores,
    setNearestStores,
    visibleStores,
    setVisibleStores,
    setCurrentPage
  } = useApp(); // Get store locations from context

  const { openModal, isModalOpen, closeModal } = useModal();

  const findNearestStores = (userLatLng) => {
    const storesWithDistance = locations.map((store) => {
      const storeLatLng = {
        lat: store.PIAB__Coordinates__c.latitude,
        lng: store.PIAB__Coordinates__c.longitude
      };
      // Calculate distance between user location and store location
      const distance = haversineDistance(userLatLng, storeLatLng);
      return { ...store, distance };
    });

    // Sort stores by distance (nearest first)
    const sortedStores = storesWithDistance.sort((a, b) => a.distance - b.distance);

    // Update the nearest stores
    setNearestStores(sortedStores);
  };

  const handlePlaceSelected = (latLng) => {
    setUserLocation(latLng); // Set user-selected location
    findNearestStores(latLng); // Find nearest stores
  };

  const loadMoreStores = () => {
    setVisibleStores((prev) => prev + 3); // Show 3 more stores
  };


  useEffect(() => {
    if (selectedLocation) {
      handlePlaceSelected(selectedLocation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation]);

  // Handler function for redirecting
  const handleSelect = async  (store) => {

    if (!fbApiUrl) {
      console.error("Error: fbApiUrl is not defined!");
    } 
    else {
      try{
     
        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const clientIp = ipData.ip; // Extracted IP Address

        // Get User Agent
        const userAgent = navigator.userAgent;

        const data = {
          data: [
            {
              event_name: "Select Store",
              event_time: Math.floor(Date.now() / 1000),
              user_data: {
                client_ip_address: clientIp,
                client_user_agent: userAgent,
              },
              action_source: "website",
              custom_data: {
                store_name: store.Name,
              },
            },
          ],
          test_event_code: "TEST58912",
        };
      
        const response = await fetch(fbApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
    
        const result = await response.json();
      }
      catch (error) {
        console.error("Error sending data to Facebook API:", error);
      }
    }
    

    setForm({
      ...form,
      location: store
    }); // Call the passed-down function
    setCurrentPage('date-picker'); // Redirect to /date-picker route
  };

  return (
    <>
      <div>
        {userLocation && (
          <div>
            {nearestStores
              .filter((store) => store.Brand__c === 'Optical Superstore') // Filter stores
              .slice(0, visibleStores)
              .map((store) => (
                <div key={store.Id} className="store-item">
                  <div style={{ width: '100%' }}>
                    <div className="heading-section">
                      <h3>{store.Name}</h3>
                      <div className="distance-container">
                        <img
                          src={getAssetUrl(locationIcon)}
                          className="location-icon"
                          alt="Location Icon"
                        />
                        <div className="distance">
                          ({store.distance.toFixed(2)} km away)
                        </div>
                      </div>
                    </div>

                    <div style={{ marginTop: 20 }}>
                      <p className="address">
                        <Address address={store.PIAB__Street__c} /> {store.PIAB__City__c}{' '}
                        {store.PIAB__State__c} {store.PIAB__Postal_Code__c}
                      </p>
                      <p className="phone">Phone: {store.PIAB__Phone__c || 'Not available'}</p>
                      <div
                        className="store-details"
                        onClick={() => {
                          setSelectedStore(store);
                          openModal('');
                        }}
                      >
                        Store details
                        <img className="arrow-icon" src={getAssetUrl(arrowIcon)} alt="Arrow Icon" />
                      </div>
                    </div>
                  </div>
                  <button className="select-button select-location" onClick={() => handleSelect(store)}>
                    Select
                  </button>
                </div>
              ))}
          </div>
        )}
        {visibleStores <
          nearestStores.filter((store) => store.Brand__c === 'Optical Superstore').length && (
          <button className="more-button show-more-location" onClick={loadMoreStores}>
            SHOW 3 MORE STORES
          </button>
        )}
      </div>
      <StoreModal isOpen={isModalOpen} onClose={closeModal} store={selectedStore} />
    </>
  );
};

export default ListingComponent;
